import React from "react";
import { Menu } from "@mui/material";

/**
 * MenuComponent
 * Centralized MUI Menu with consistent Paper styling.
 * Defaults to inherited font (or pass "Source Sans Pro, sans-serif").
 */
function MenuComponent({
  anchorEl,
  open,
  onClose,
  children,
  width = "12.5rem",
  zIndex = 1300,
  fontFamily = "inherit",
  paperSx = {},
  listSx = {},
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  transformOrigin,
  ...rest
}: any) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{ "& .MuiList-root": { p: 0, ...listSx } }}
      PaperProps={{
        sx: {
          border: "1px solid #ECF3FE",
          boxShadow: "0.25rem 0.25rem 0.9375rem rgba(65, 92, 171, 0.15)",
          backgroundColor: "#FFFFFF",
          width,
          zIndex,
          fontFamily,
          "& *": { fontFamily: "inherit" },
          ...paperSx,
        },
      }}
      {...rest}
    >
      {children}
    </Menu>
  );
}

export default MenuComponent;
